module.exports = __webpack_public_path__ + "static/media/cash-for-damaged-car2.d11062dc.png";